module.exports = __webpack_public_path__ + "img/renqi@2x.90679b24.png";